import React from 'react'
import Accordions from '../../../components/Accordions'

const Sem3Ece1 = () => {
  const data = [
    {
      subjectName: "2023 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/1uCQ9yhJjrlw05s4Xf4gmBPe21q3-7_hq/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
    {
      subjectName: "2024 Batch",
      units: [],
      links: [
        {
          url: "https://drive.google.com/file/d/1kea2PanY_HkliEnWFFjdhw2aILvqEkDy/view?usp=drive_link",
          title: "Syllabus",
        },
      ],
    },
            {
      subjectName: "2025 Batch",
      units: [ ],
      links: [
        {
          url: "",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">ECE Sem - 3</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem3Ece1